import styled from "styled-components";
import FlexBox from "../../Components/FlexBox/FlexBox";
import { defaultTheme } from "../../Themes/defaultTheme";
import hexToRgba from "hex-to-rgba";

export const _ProductLineImageWrapper = styled("div")<{ $size: number }>(
  ({ $size }) => {
    return {
      position: "relative",
      width: $size,
      height: $size,
    };
  }
);

export const _ProductLineRoot = styled(FlexBox)<{
  $editable?: boolean;
  $isFree?: boolean;
}>(({ $editable = true, $isFree = false }) => {
  const { color } = defaultTheme;
  return {
    pointerEvents: !$editable ? "none" : undefined,
    cursor: $editable ? "pointer" : undefined,
    userSelect: "none",
    overflow: "visible",
    position: "relative",
    [".product-line__subtitle"]: {
      [".unavailable"]: {
        color: color.warning,
        textDecoration: "line-through",
      },
    },
    [".product-line__pieces"]: {
      display: "inline-block",
    },
    ...($isFree && {
      background: hexToRgba(color.blueExplorer, 0.05),
      borderRadius: 4,
      ".product-line__name": {
        fontWeight: 500,
      },
      ".product-line__right": {
        // width: 64,
        justifyContent: "center",
        color: color.blueExplorer,
      },
    }),
  };
});

export const _ProductLineTag = styled("div")({
  backgroundColor: defaultTheme.color.discountProduct,
  padding: "1px 4px",
  borderRadius: 2,
  position: "absolute",
  top: 9,
  right: 12,
});
